import React from "react";
import { Input } from "@sonder/ui/source/styled/fragments/Input";

interface QuantityFieldProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

export const QuantityField = ({
  type,
  value,
  onChange,
  min,
  placeholder,
}: QuantityFieldProps) => {
  return (
    <Input
      min={min}
      placeholder={placeholder}
      type={type}
      value={value ?? min}
      onChange={onChange}
    />
  );
};
